import { DailyTasksService } from './DailyTasksService';
import { PartnersService } from './PartnersService';
import { SponsorsService } from './SponsorsService';
import { TaskType, Task } from '../types';

export class TasksService {
  static async getTasks(type: TaskType, groupId?: number): Promise<Task[]> {
    console.log('🚀 TasksService.getTasks - start', { type, groupId });

    try {
      // Для спонсорских заданий используем отдельную логику без groupId
      if (type === 'sponsors') {
        const sponsorTasks = await SponsorsService.getSponsorTasks();
        return sponsorTasks;
      }
      if (type === 'daily-bonus') {
        console.log('🚀 ======= TasksService.getTasks - daily-bonus');
        return [];
      }

      // Для остальных типов требуется groupId
      if (!groupId) {
        throw new Error(`Group ID is required for ${type} tasks`);
      }
      switch (type) {
        case 'quest-daily':
          return await DailyTasksService.getDailyTasks(groupId);
        case 'partners':
          return await PartnersService.getPartnerTasks(groupId);
        default:
          throw new Error(`Unknown task type: ${type}`);
      }
    } catch (error) {
      console.error('❌ TasksService.getTasks - error', error);
      throw error;
    }
  }

  static async claimReward(type: TaskType, taskId: number | string, groupId?: number): Promise<any> {
    try {
      let response;
      switch (type) {
        case 'sponsors':
          response = await SponsorsService.claimSponsorTask(taskId);
          break;
        case 'quest-daily':
          response = await DailyTasksService.claimDailyTask(taskId);
          break;
        case 'partners':
          if (!groupId) {
            throw new Error('Group ID is required for partner tasks');
          }
          response = await PartnersService.claimPartnerTask(taskId, groupId);
          break;
        default:
          throw new Error(`Unknown task type: ${type}`);
      }
      return response;
    } catch (error) {
      console.error('❌ TasksService.claimReward - error', error);
      throw error;
    }
  }
} 
